import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '@app/store/store';
import { setCurrentUser } from '@store/reducers/auth';
import { toggleSidebarMenu, toggleMobileSidebar } from '@app/store/reducers/ui';

const ASSETS = '/assets';

const Header = () => {
  const dispatch    = useAppDispatch();
  const navigate    = useNavigate();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  const [notifOpen, setNotifOpen] = useState(false);
  const [cartOpen,  setCartOpen]  = useState(false);
  const [userOpen,  setUserOpen]  = useState(false);
  const [appOpen,   setAppOpen]   = useState(false);

  const userDropdownRef = useRef<HTMLDivElement>(null);

  const closeAll = () => {
    setNotifOpen(false);
    setCartOpen(false);
    setUserOpen(false);
    setAppOpen(false);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target as Node)) {
        setUserOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    // Clear Redux state
    dispatch(setCurrentUser(null));
    // Clear persisted session — without this, AuthContext.checkAuth()
    // finds the token in localStorage on refresh and auto-logs the user back in.
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.success('Logged out successfully');
    navigate('/login');
  };

  const handleToggleSidebar = () => {
    if (window.innerWidth < 1200) {
      dispatch(toggleMobileSidebar());
    } else {
      dispatch(toggleSidebarMenu());
    }
  };

  const noop = (e: React.MouseEvent) => e.preventDefault();

  return (
    <header>
      <div className="topbar d-flex align-items-center">
        <nav className="navbar navbar-expand gap-3">

          {/* Mobile sidebar toggle */}
          <div
            className="mobile-toggle-menu"
            onClick={handleToggleSidebar}
            style={{ cursor: 'pointer' }}
          >
            <i className="bx bx-menu" />
          </div>

          {/* Top-right nav icons */}
          <div className="top-menu ms-auto">
            <ul className="navbar-nav align-items-center gap-1">
              {/* Notification dropdown can be added here */}
            </ul>
          </div>

          {/* User Dropdown - Fixed positioning */}
          <div className={`user-box dropdown px-3${userOpen ? ' show' : ''}`} ref={userDropdownRef}>
            <a
              className="d-flex align-items-center nav-link dropdown-toggle gap-3 dropdown-toggle-nocaret"
              href="#"
              onClick={(e) => { e.preventDefault(); closeAll(); setUserOpen((p) => !p); }}
            >
              <img
                src={`${ASSETS}/images/avatars/avatar-7.png`}
                className="user-img"
                alt="user avatar"
              />
              <div className="user-info">
                <p className="user-name mb-0">
                  {(currentUser as any)?.displayName || currentUser?.full_name || 'Admin User'}
                </p>
                <p className="user-name mb-0">
                  {(currentUser as any)?.displayName || currentUser?.email || 'Admin User'}
                </p>
              </div>
            </a>
            {userOpen && (
              <ul className="dropdown-menu dropdown-menu-end show" style={{ position: 'absolute', top: '100%', right: '0', left: 'auto', marginTop: '0.125rem' }}>
          
                <li>
                  <a
                    className="dropdown-item d-flex align-items-center"
                    href="#"
                    onClick={(e) => { e.preventDefault(); handleLogout(); }}
                  >
                    <i className="bx bx-log-out-circle" /><span className="ms-2">Logout</span>
                  </a>
                </li>
              </ul>
            )}
          </div>

        </nav>
      </div>
    </header>
  );
};

export default Header;